// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               unknown
// source: photon/imessage/v1/attachment_types.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "photon.imessage.v1";

/**
 * Mirrors chat.db `attachment.transfer_state` (Apple `IMTransferState`); wire
 * values equal DB values, gaps included. Zero is `PENDING`, not
 * `UNSPECIFIED`; the server always populates this field.
 */
export enum TransferState {
  TRANSFER_STATE_PENDING = 0,
  TRANSFER_STATE_UNAVAILABLE = -1,
  TRANSFER_STATE_TRANSFERRING = 1,
  TRANSFER_STATE_FAILED = 2,
  TRANSFER_STATE_FINISHED = 5,
  TRANSFER_STATE_UNKNOWN = 6,
}

export function transferStateFromJSON(object: any): TransferState {
  switch (object) {
    case 0:
    case "TRANSFER_STATE_PENDING":
      return TransferState.TRANSFER_STATE_PENDING;
    case -1:
    case "TRANSFER_STATE_UNAVAILABLE":
      return TransferState.TRANSFER_STATE_UNAVAILABLE;
    case 1:
    case "TRANSFER_STATE_TRANSFERRING":
      return TransferState.TRANSFER_STATE_TRANSFERRING;
    case 2:
    case "TRANSFER_STATE_FAILED":
      return TransferState.TRANSFER_STATE_FAILED;
    case 5:
    case "TRANSFER_STATE_FINISHED":
      return TransferState.TRANSFER_STATE_FINISHED;
    case 6:
    case "TRANSFER_STATE_UNKNOWN":
      return TransferState.TRANSFER_STATE_UNKNOWN;
    default:
      return TransferState.TRANSFER_STATE_UNAVAILABLE;
  }
}

export function transferStateToJSON(object: TransferState): string {
  switch (object) {
    case TransferState.TRANSFER_STATE_PENDING:
      return "TRANSFER_STATE_PENDING";
    case TransferState.TRANSFER_STATE_UNAVAILABLE:
      return "TRANSFER_STATE_UNAVAILABLE";
    case TransferState.TRANSFER_STATE_TRANSFERRING:
      return "TRANSFER_STATE_TRANSFERRING";
    case TransferState.TRANSFER_STATE_FAILED:
      return "TRANSFER_STATE_FAILED";
    case TransferState.TRANSFER_STATE_FINISHED:
      return "TRANSFER_STATE_FINISHED";
    case TransferState.TRANSFER_STATE_UNKNOWN:
      return "TRANSFER_STATE_UNKNOWN";
    default:
      return "TRANSFER_STATE_UNAVAILABLE";
  }
}

/**
 * Sidecar attachment kind. Today only Live Photo's `.mov` companion is
 * modelled.
 */
export enum CompanionKind {
  COMPANION_KIND_UNSPECIFIED = 0,
  COMPANION_KIND_LIVE_PHOTO_VIDEO = 1,
  UNRECOGNIZED = -1,
}

export function companionKindFromJSON(object: any): CompanionKind {
  switch (object) {
    case 0:
    case "COMPANION_KIND_UNSPECIFIED":
      return CompanionKind.COMPANION_KIND_UNSPECIFIED;
    case 1:
    case "COMPANION_KIND_LIVE_PHOTO_VIDEO":
      return CompanionKind.COMPANION_KIND_LIVE_PHOTO_VIDEO;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CompanionKind.UNRECOGNIZED;
  }
}

export function companionKindToJSON(object: CompanionKind): string {
  switch (object) {
    case CompanionKind.COMPANION_KIND_UNSPECIFIED:
      return "COMPANION_KIND_UNSPECIFIED";
    case CompanionKind.COMPANION_KIND_LIVE_PHOTO_VIDEO:
      return "COMPANION_KIND_LIVE_PHOTO_VIDEO";
    case CompanionKind.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface AttachmentInfo {
  guid: string;
  /**
   * Set on attachments superseded by an edit. Points to the original
   * attachment GUID this row replaced.
   */
  originalGuid?: string | undefined;
  fileName: string;
  mimeType: string;
  /** Apple Uniform Type Identifier (e.g. `public.jpeg`, `com.apple.live-photo`). */
  uti: string;
  totalBytes: number;
  isOutgoing: boolean;
  transferState: TransferState;
  /**
   * Mirrors chat.db `attachment.hide_attachment`. `true` when the
   * attachment is hidden from the conversation surface (e.g. tapback
   * sticker artifacts).
   */
  isHidden: boolean;
  isSticker: boolean;
  /**
   * Set iff this attachment ships with a sidecar; the server never emits
   * `COMPANION_KIND_UNSPECIFIED`.
   */
  companionKind?: CompanionKind | undefined;
}

export interface CompanionInfo {
  fileName: string;
  mimeType: string;
  totalBytes: number;
  kind: CompanionKind;
}

/**
 * Inline-bytes companion sent on upload. The on-disk file name is derived
 * from the primary's stem plus an extension determined by `kind`.
 */
export interface Companion {
  data: Uint8Array;
  kind: CompanionKind;
}

function createBaseAttachmentInfo(): AttachmentInfo {
  return {
    guid: "",
    originalGuid: undefined,
    fileName: "",
    mimeType: "",
    uti: "",
    totalBytes: 0,
    isOutgoing: false,
    transferState: 0,
    isHidden: false,
    isSticker: false,
    companionKind: undefined,
  };
}

export const AttachmentInfo: MessageFns<AttachmentInfo> = {
  encode(message: AttachmentInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.guid !== "") {
      writer.uint32(10).string(message.guid);
    }
    if (message.originalGuid !== undefined) {
      writer.uint32(18).string(message.originalGuid);
    }
    if (message.fileName !== "") {
      writer.uint32(26).string(message.fileName);
    }
    if (message.mimeType !== "") {
      writer.uint32(34).string(message.mimeType);
    }
    if (message.uti !== "") {
      writer.uint32(42).string(message.uti);
    }
    if (message.totalBytes !== 0) {
      writer.uint32(48).int64(message.totalBytes);
    }
    if (message.isOutgoing !== false) {
      writer.uint32(56).bool(message.isOutgoing);
    }
    if (message.transferState !== 0) {
      writer.uint32(64).int32(message.transferState);
    }
    if (message.isHidden !== false) {
      writer.uint32(72).bool(message.isHidden);
    }
    if (message.isSticker !== false) {
      writer.uint32(80).bool(message.isSticker);
    }
    if (message.companionKind !== undefined) {
      writer.uint32(88).int32(message.companionKind);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AttachmentInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAttachmentInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.guid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.originalGuid = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.fileName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.mimeType = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.uti = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.totalBytes = longToNumber(reader.int64());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.isOutgoing = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.transferState = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.isHidden = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.isSticker = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.companionKind = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AttachmentInfo {
    return {
      guid: isSet(object.guid) ? globalThis.String(object.guid) : "",
      originalGuid: isSet(object.originalGuid)
        ? globalThis.String(object.originalGuid)
        : isSet(object.original_guid)
        ? globalThis.String(object.original_guid)
        : undefined,
      fileName: isSet(object.fileName)
        ? globalThis.String(object.fileName)
        : isSet(object.file_name)
        ? globalThis.String(object.file_name)
        : "",
      mimeType: isSet(object.mimeType)
        ? globalThis.String(object.mimeType)
        : isSet(object.mime_type)
        ? globalThis.String(object.mime_type)
        : "",
      uti: isSet(object.uti) ? globalThis.String(object.uti) : "",
      totalBytes: isSet(object.totalBytes)
        ? globalThis.Number(object.totalBytes)
        : isSet(object.total_bytes)
        ? globalThis.Number(object.total_bytes)
        : 0,
      isOutgoing: isSet(object.isOutgoing)
        ? globalThis.Boolean(object.isOutgoing)
        : isSet(object.is_outgoing)
        ? globalThis.Boolean(object.is_outgoing)
        : false,
      transferState: isSet(object.transferState)
        ? transferStateFromJSON(object.transferState)
        : isSet(object.transfer_state)
        ? transferStateFromJSON(object.transfer_state)
        : 0,
      isHidden: isSet(object.isHidden)
        ? globalThis.Boolean(object.isHidden)
        : isSet(object.is_hidden)
        ? globalThis.Boolean(object.is_hidden)
        : false,
      isSticker: isSet(object.isSticker)
        ? globalThis.Boolean(object.isSticker)
        : isSet(object.is_sticker)
        ? globalThis.Boolean(object.is_sticker)
        : false,
      companionKind: isSet(object.companionKind)
        ? companionKindFromJSON(object.companionKind)
        : isSet(object.companion_kind)
        ? companionKindFromJSON(object.companion_kind)
        : undefined,
    };
  },

  toJSON(message: AttachmentInfo): unknown {
    const obj: any = {};
    if (message.guid !== "") {
      obj.guid = message.guid;
    }
    if (message.originalGuid !== undefined) {
      obj.originalGuid = message.originalGuid;
    }
    if (message.fileName !== "") {
      obj.fileName = message.fileName;
    }
    if (message.mimeType !== "") {
      obj.mimeType = message.mimeType;
    }
    if (message.uti !== "") {
      obj.uti = message.uti;
    }
    if (message.totalBytes !== 0) {
      obj.totalBytes = Math.round(message.totalBytes);
    }
    if (message.isOutgoing !== false) {
      obj.isOutgoing = message.isOutgoing;
    }
    if (message.transferState !== 0) {
      obj.transferState = transferStateToJSON(message.transferState);
    }
    if (message.isHidden !== false) {
      obj.isHidden = message.isHidden;
    }
    if (message.isSticker !== false) {
      obj.isSticker = message.isSticker;
    }
    if (message.companionKind !== undefined) {
      obj.companionKind = companionKindToJSON(message.companionKind);
    }
    return obj;
  },

  create(base?: DeepPartial<AttachmentInfo>): AttachmentInfo {
    return AttachmentInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AttachmentInfo>): AttachmentInfo {
    const message = createBaseAttachmentInfo();
    message.guid = object.guid ?? "";
    message.originalGuid = object.originalGuid ?? undefined;
    message.fileName = object.fileName ?? "";
    message.mimeType = object.mimeType ?? "";
    message.uti = object.uti ?? "";
    message.totalBytes = object.totalBytes ?? 0;
    message.isOutgoing = object.isOutgoing ?? false;
    message.transferState = object.transferState ?? 0;
    message.isHidden = object.isHidden ?? false;
    message.isSticker = object.isSticker ?? false;
    message.companionKind = object.companionKind ?? undefined;
    return message;
  },
};

function createBaseCompanionInfo(): CompanionInfo {
  return { fileName: "", mimeType: "", totalBytes: 0, kind: 0 };
}

export const CompanionInfo: MessageFns<CompanionInfo> = {
  encode(message: CompanionInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fileName !== "") {
      writer.uint32(10).string(message.fileName);
    }
    if (message.mimeType !== "") {
      writer.uint32(18).string(message.mimeType);
    }
    if (message.totalBytes !== 0) {
      writer.uint32(24).int64(message.totalBytes);
    }
    if (message.kind !== 0) {
      writer.uint32(32).int32(message.kind);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompanionInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompanionInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fileName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.mimeType = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.totalBytes = longToNumber(reader.int64());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompanionInfo {
    return {
      fileName: isSet(object.fileName)
        ? globalThis.String(object.fileName)
        : isSet(object.file_name)
        ? globalThis.String(object.file_name)
        : "",
      mimeType: isSet(object.mimeType)
        ? globalThis.String(object.mimeType)
        : isSet(object.mime_type)
        ? globalThis.String(object.mime_type)
        : "",
      totalBytes: isSet(object.totalBytes)
        ? globalThis.Number(object.totalBytes)
        : isSet(object.total_bytes)
        ? globalThis.Number(object.total_bytes)
        : 0,
      kind: isSet(object.kind) ? companionKindFromJSON(object.kind) : 0,
    };
  },

  toJSON(message: CompanionInfo): unknown {
    const obj: any = {};
    if (message.fileName !== "") {
      obj.fileName = message.fileName;
    }
    if (message.mimeType !== "") {
      obj.mimeType = message.mimeType;
    }
    if (message.totalBytes !== 0) {
      obj.totalBytes = Math.round(message.totalBytes);
    }
    if (message.kind !== 0) {
      obj.kind = companionKindToJSON(message.kind);
    }
    return obj;
  },

  create(base?: DeepPartial<CompanionInfo>): CompanionInfo {
    return CompanionInfo.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CompanionInfo>): CompanionInfo {
    const message = createBaseCompanionInfo();
    message.fileName = object.fileName ?? "";
    message.mimeType = object.mimeType ?? "";
    message.totalBytes = object.totalBytes ?? 0;
    message.kind = object.kind ?? 0;
    return message;
  },
};

function createBaseCompanion(): Companion {
  return { data: new Uint8Array(0), kind: 0 };
}

export const Companion: MessageFns<Companion> = {
  encode(message: Companion, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data.length !== 0) {
      writer.uint32(10).bytes(message.data);
    }
    if (message.kind !== 0) {
      writer.uint32(16).int32(message.kind);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Companion {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompanion();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = reader.bytes();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Companion {
    return {
      data: isSet(object.data) ? bytesFromBase64(object.data) : new Uint8Array(0),
      kind: isSet(object.kind) ? companionKindFromJSON(object.kind) : 0,
    };
  },

  toJSON(message: Companion): unknown {
    const obj: any = {};
    if (message.data.length !== 0) {
      obj.data = base64FromBytes(message.data);
    }
    if (message.kind !== 0) {
      obj.kind = companionKindToJSON(message.kind);
    }
    return obj;
  },

  create(base?: DeepPartial<Companion>): Companion {
    return Companion.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Companion>): Companion {
    const message = createBaseCompanion();
    message.data = object.data ?? new Uint8Array(0);
    message.kind = object.kind ?? 0;
    return message;
  },
};

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from((globalThis as any).Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return (globalThis as any).Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
